import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import {
  DELETE_FIND_MUTATION,
  removeFindsFromCache,
  removeFindTagAssignmentsFromCache,
} from '../../gql';
import { FormattedMessage } from 'react-intl';
import { DangerZoneAction } from '../design-system';

const DeleteFindControl = React.memo(
  ({ id, siteId }: { id: string; siteId?: string }) => {
    const [active, setActive] = useState(false);
    const navigate = useNavigate();

    const [
      deleteFind,
      { loading: loadingDelete, called: calledDelete },
    ] = useMutation(DELETE_FIND_MUTATION, {
      update: (cache, { data }) => {
        if (data?.deleteFind?.result) {
          removeFindTagAssignmentsFromCache(cache, [id]);
          removeFindsFromCache(cache, [id]);
        }
      },
      onCompleted: () => {
        // todo: for groups, add group id and resolve IF siteId ...or IF groupId
        if (siteId) {
          navigate(`/s/${siteId}/finds`);
        }
      },
    });

    const handleActiveChange = (nextActive: boolean) => {
      setActive(nextActive);
    };

    const handleDeleteClick = async () => {
      await deleteFind({ variables: { id } });
    };

    return (
      <DangerZoneAction
        actionIcon={<DeleteIcon />}
        actionLabel={
          <FormattedMessage
            id="find.delete.permanently"
            defaultMessage="Permanently delete"
          />
        }
        active={active}
        disabled={loadingDelete || calledDelete}
        label={
          <FormattedMessage
            id="find.delete.enable"
            defaultMessage="Delete find"
          />
        }
        onAction={handleDeleteClick}
        onActiveChange={handleActiveChange}
      />
    );
  }
);

export { DeleteFindControl };
